<template>
    <wrap class="d_wrap" ref="wrap" :title="title">

        <div class="pay-methods">

            <ul class="clearBoth">
                <li @click="changeTab(li)" :class="{'b_f-color': li.selected, active: li.selected}"
                    v-for="(li, index) in tabs" :key="'tab' + index">{{li.title}}
                </li>
            </ul>

            <div class="input-wrap">
                <span>充值通道：</span>
                <label>
                    <input type="radio" v-model="way" value="0"> <span>通道1</span>
                </label>
                <label>
                    <input type="radio" v-model="way" value="1"> <span>通道2</span>
                </label>

                <label class="block">
                    <span class="label">充值金额：</span>
                    <input class="text" type="text">
                </label>

                <event tag="button" class="recharge normal-btn t_btn-d active">确认</event>
            </div>
        </div>


        <div class="table">
            <v-table :head="head" :body="body"></v-table>
        </div>

    </wrap>
</template>

<script>
  // qc15复用qc14
  import VTable from './table';
  import Wrap from "./wrap";
  import mixin from "./mixin";

  export default {
    name: "QC27",
    mixins: [mixin],
    components: {Wrap, VTable},
    computed: {
      head () {
        return this.data.head || [
          {label: '时间', value: 'time'},
          {label: '充值方式', value: 'type'},
          {label: '金额', value: 'money'},
          {label: '年续费/优惠奖励', value: 'yearCard'},
          {label: '交易描述', value: 'desc'},
          {label: '单据状态', value: 'status'},
          {label: '订单号', value: 'order_num'},
        ];
      },
      body () {
        return this.data.body || [
          {
            time: '2019-07-02 11:12:23',
            type: '手动存入',
            value: 200,
            yearCard: 50,
            desc: 'd0007送18彩金',
            status: '已充值',
            order_num: 'NO2019089078970809'
          },
          {
            time: '2019-07-02 11:12:23',
            type: '手动存入',
            value: 200,
            yearCard: 50,
            desc: 'd0007送18彩金',
            status: '已充值',
            order_num: 'NO2019089078970809'
          }, {
            time: '2019-07-02 11:12:23',
            type: '手动存入',
            value: 200,
            yearCard: 50,
            desc: 'd0007送18彩金',
            status: '已充值',
            order_num: 'NO2019089078970809'
          }, {
            time: '2019-07-02 11:12:23',
            type: '手动存入',
            value: 200,
            yearCard: 50,
            desc: 'd0007送18彩金',
            status: '已充值',
            order_num: 'NO2019089078970809'
          }, {
            time: '2019-07-02 11:12:23',
            type: '手动存入',
            value: 200,
            yearCard: 50,
            desc: 'd0007送18彩金',
            status: '已充值',
            order_num: 'NO2019089078970809'
          },
        ]
      }
    },
    data() {
      return {
        tabs: [
          {
            value: 0,
            title: '支付宝',
            selected: true
          },
          {
            value: 1,
            title: '微信',
            selected: false
          },
        ],
        way: 0
      };
    },
    methods: {
      changeTab(li) {
        this.tabs.forEach(_li => {
          _li.selected = li.value == _li.value;
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .d_wrap {
        font-size 16px
        .pay-methods {
            ul {
                li {
                    cursor pointer
                    width 80px
                    float left
                    text-align center
                    box-sizing border-box
                    padding-bottom 15px
                    &.active {
                        border-bottom 1px solid
                    }
                }
            }
            .input-wrap {
                margin-top 30px
                label {
                    input {
                        vertical-align middle
                        margin 0
                    }
                    span {
                    }
                }
                .recharge {
                    width 80px
                    height 35px
                    margin-top 20px
                    border-radius 4px
                }
            }
        }
        .table {
            margin-top 20px
        }
    }

    .block {
        display block
        margin-top 20px
        input {
            height 35px
            outline nono
            border 1px solid #e6e6e6
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC27.vue